import { ROLE_IDS } from '@/auth/utils'

export default [
  {
    title: 'Kelola User',
    komicon: 'k-security-user',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Role Akses',
        komicon: 'k-shield-security',
        route: 'role-access',
        resource: 'Kelola User - Role Akses',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'User',
        komicon: 'k-key-square',
        route: 'user',
        resource: 'Kelola User - User',
        action: 'manage',
        allowedRoles: [ROLE_IDS.ADMIN],
      },
      {
        title: 'Credential Management',
        komicon: 'k-key',
        route: 'CredentialManagement',
        resource: 'Kelola User - Credential Management',
        action: 'manage',
      },
      {
        title: 'Pusat Bantuan',
        komicon: 'k-message-question',
        route: 'PusatBantuan',
        resource: 'Kelola User - Pusat Bantuan',
        action: 'manage',
      },
    ],
  },
]
